/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { conditionService, dynamicConditionService } from '../../api/services';
import { showToast } from '../../components/Toast/showToast';
import DynamicConditionForm from './DynamicConditionForm';
import { DependentCondition, DynamicConditionFormValues } from '../../types/DynamicCondition.types';

const UpdateDynamicCondition = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [relationType, setRelationType] = useState<string>('');
  const [initialDataDynamic, setInitialDataDynamic] = useState<DynamicConditionFormValues>({
    principalConditionId: id as string,
  });
  const navigateToListConditions = useCallback(() => {
    navigate('/conditions');
  }, []);

  const handleSubmit = useCallback(async (data: DynamicConditionFormValues) => {
    const ListConditionDepedent =
      data.listDepedentCondition?.map((dependentCondition) => ({
        IdCondicaoDependente: dependentCondition.dependentConditionId?.value || '',
        Values:
          dependentCondition.values?.map((value) => ({
            ValorCondicaoPrincipal: value.principalConditionValue.value || undefined,
            ValorCondicaoDependente: value.dependentConditionValue.value || undefined,
          })) || [],
      })) || [];

    const successfullyUpdated = await dynamicConditionService.update({
      IdCondicaoPrincipal: data.principalConditionId,
      ListaCondicoesDepedentes: ListConditionDepedent,
    });

    if (successfullyUpdated) {
      showToast({
        type: 'success',
        text: 'Sucesso ao cadastrar condição.',
      });
      navigateToListConditions();
    }
  }, []);

  useEffect(() => {
    async function getInitialData() {
      const conditionData = await conditionService.getById(id as string);
      const principalConditionId =
        conditionData?.tipoRelacao === 'Principal'
          ? conditionData?.idModeloCondicao
          : conditionData!.conditionRelacao![0].idCondicaoPrincipal;
      setRelationType(conditionData?.tipoRelacao as string);

      if (conditionData?.conditionRelacao != null) {
        const dependentconditionsMap = new Map<string, DependentCondition>();

        //Pegue todas as condicoes relacoes que existir daquela condicao, e crie um dicionario chave valor, onde o indice é o idCondicaoDepedente que é idModeloCondicao.
        conditionData.conditionRelacao.forEach((el) => {
          if (!dependentconditionsMap.has(el.idCondicaoDependente)) {
            dependentconditionsMap.set(el.idCondicaoDependente, {
              dependentConditionId: {
                label: el.idCondicaoDependente,
                value: el.idCondicaoDependente,
              },
              values: [
                {
                  principalConditionValue: {
                    label: el.condicaoPrincipal.descricao || '',
                    value: el.valorCondicaoPrincipal,
                  },
                  dependentConditionValue: {
                    label: el.condicaoDependente.descricao || '',
                    value: el.valorCondicaoDependente,
                  },
                },
              ],
            });
          } else {
            const existingcondition = dependentconditionsMap.get(el.idCondicaoDependente);
            existingcondition?.values?.push({
              principalConditionValue: {
                label: el.condicaoPrincipal.descricao || '',
                value: el.valorCondicaoPrincipal,
              },
              dependentConditionValue: {
                label: el.condicaoDependente.descricao || '',
                value: el.valorCondicaoDependente,
              },
            });
          }
        });
        setInitialDataDynamic({
          principalConditionId: principalConditionId as string,
          listDepedentCondition: Array.from(dependentconditionsMap.values()),
        });
      }
      setIsLoading(false);
    }
    getInitialData();
    //getRelationData();
  }, []);

  return !isLoading ? (
    <>
      <DynamicConditionForm relationType={relationType} initialData={initialDataDynamic} onSubmit={handleSubmit} />
    </>
  ) : null;
};

export default UpdateDynamicCondition;
